import { Box, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { memo, ReactNode } from 'react';

import { CopilotAction } from 'components/copilotDropdown';
import { KeyboardKeyCombinations } from 'components/keyboard';
import { KeyboardKeyCombination } from 'utils/keyboard';

type CopilotSelectionListItemContentProps = Pick<CopilotAction, 'icon'> & {
  readonly title: string | ReactNode;
  readonly keyCombinations?: readonly KeyboardKeyCombination[];
  readonly pinned?: boolean;
  actionName: string;
};

/**
 * Represents normalized item content that should be used in copilot actions
 * selection list
 */
export const CopilotSelectionListItemContent = memo(
  function CopilotSelectionListItemContent({
    icon,
    title,
    keyCombinations,
  }: CopilotSelectionListItemContentProps) {
    return (
      <FlexBox gap="200" alignItems="center">
        <FlexBox flex="0" alignItems="center">
          <Icon name={icon} />
        </FlexBox>

        <Box flex="1">
          <Text.Paragraph>{title}</Text.Paragraph>
        </Box>

        <Box flex="0">
          <Text.Paragraph as="span" color="tertiary">
            {!!keyCombinations?.length && (
              <KeyboardKeyCombinations keyCombinations={keyCombinations} />
            )}
          </Text.Paragraph>
        </Box>
      </FlexBox>
    );
  },
);
